"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDay2ApiVipDialogToggle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const ModalDialogsContext_1 = require("./ModalDialogsContext");
const common_1 = require("../../../common");
const UpdateDay2ApiVipDialogToggle = () => {
    const { UpdateDay2ApiVipDialog: { open }, } = (0, ModalDialogsContext_1.useModalDialogsContext)();
    const { canEdit } = react_1.default.useContext(common_1.AddHostsContext);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        "Check your DNS and network configuration, or",
        ' ',
        canEdit ? (react_1.default.createElement(react_core_1.AlertActionLink, { onClick: () => open(), isInline: true }, "set the IP or domain used to reach the cluster.")) : ('set the IP or domain used to reach the cluster.')));
};
exports.UpdateDay2ApiVipDialogToggle = UpdateDay2ApiVipDialogToggle;
//# sourceMappingURL=UpdateDay2ApiVipDialogToggle.js.map